<template>
  <div class="d-inline-flex">
    <v-text-field
      v-model="time.hour"
      :readonly="!editable"
      prepend-icon="mdi-clock-outline"
      label="เวลา"
      type="number"
      max="23"
      maxlength="2"
      min="00"
      class="hour-field"
      :disabled="disabled"
      @input="watching('hour', $event)" />
    <v-text-field
      v-model="time.minute"
      :readonly="!editable"
      type="number"
      max="59"
      min="00"
      class="minute-field"
      :disabled="disabled"
      @input="watching('minute', $event)">
      <template v-slot:prepend-inner>
        :
      </template>
    </v-text-field>
  </div>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      editable: {
        type: Boolean,
        default: false
      },
      value: {
        type: Object,
        default: () => ({
          hour: '00',
          minute: '00'
        })
      }
    },
    data () {
      return {
        time: {
          hour: '00',
          minute: '00'
        },
        watchingData: {
          hour: null,
          minute: null
        }
      }
    },
    watch: {
      editable: {
        handler () {
          this.returnValue()
        }
      }
    },
    mounted () {
      this.initDefault()
    },
    methods: {
      initDefault () {
        if (this.value) {
          this.time = this.value
          this.actionHandle('hour', this.time.hour.toString())
          this.actionHandle('minute', this.time.minute.toString())
        }
      },
      returnValue () {
        const newTime = this.$dayjs()
          .hour(this.time.hour)
          .minute(this.time.minute)
          .utc()
        this.$emit('input', { hour: newTime.hour(), minute: newTime.minute() })
      },
      watching (field, val) {
        clearTimeout(this.watchingData[field])
        this.watchingData[field] = setTimeout(() => {
          this.actionHandle(field, val)
        }, 1500)
      },
      actionHandle (field, val) {
        if (val.length >= 2) {
          this.time[field] = val.slice(0, 2)
        } else if (val.length === 1) {
          this.time[field] = `0${val}`
        } else if (!this.time[field]) {
          this.time[field] = '00'
        }

        this.returnValue()
      }
    }
  }
</script>

<style>
.hour-field input {
  text-align: right;
}

.minute-field input {
  text-align: left;
}
</style>
